// extracted by mini-css-extract-plugin
module.exports = {"header":"PanelHeader_header__cXdgI","icon":"PanelHeader_icon__2cAU9","title":"PanelHeader_title__1OH6t","actions":"PanelHeader_actions__20vt3"};